import comp from "./ConfigureAIVoiceWrapper";
export default comp;
